// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UasXA","largestCol":"styles_largestCol__RxADp","smallestCol":"styles_smallestCol__2hQT0"};